module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEPSURBVHgB3ZThEYIwDIVTJ2ADcQJH0BE6Ak6CTqAb6Aa6gTqBbFCdQDeIL2c9KwYpiH/47nLlmte8tkCIeg0zJ4gMsUU4fnHycxm1BYst4sr1uMZGWLDk5uSxxXNuz7KueMa/Y8OapmTgMKT0GzfEyBgjIw3C3SvFFxDKJhZKoapcgrAfahjsymct5aNzUuuZGwS6oWKah2NsDoyfDybcBXWIv763E/yF0OBC3VFoBoUilM/tK6JR1l00g50iXFM9W2XusxY/OqfW3KRzpoo+RewVvQt15T/ZVuxIOCCO/nmCmFboZri5DVUBkxW3Z04xiJCbs6Im8KOzuojC8t4stcUbSZ8qgqJnPye5hHrNHaeDa0zYIPbLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/Images/emojiwhticn.png
// module id = 1177
// module chunks = 0